import React from 'react';
import { StoreMap, stores } from '../components/map/StoreMap';
import { KPICard } from '../components/ui/KPICard';
import { Star, MessageSquare, Store } from 'lucide-react';
export function HeatmapPage() {
  return <div className="flex flex-col h-[calc(100vh-64px)]" data-id="element-575">
      {/* KPI Overlay / Header Area */}
      <div className="px-6 py-6 bg-aldi-light z-10" data-id="element-576">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-577">
          <KPICard title="Anzahl Märkte" value={stores.length.toString()} icon={<Store size={18} data-id="element-579" />} data-id="element-578" />
          <KPICard title="Ø Bewertungs-Score" value="4,1" icon={<Star size={18} data-id="element-581" />} data-id="element-580" />
          <KPICard title="Bewertungen gesamt" value="8.742" icon={<MessageSquare size={18} data-id="element-583" />} data-id="element-582" />
        </div>
      </div>

      {/* Map Area */}
      <div className="flex-1 relative border-t border-gray-200" data-id="element-584">
        <StoreMap data-id="element-585" />
      </div>
    </div>;
}